module.exports = __webpack_public_path__ + "static/media/waves-min2.eecfb11c.jpg";